import { render, staticRenderFns } from "./ConfigIni.vue?vue&type=template&id=3d720647&scoped=true&"
import script from "./ConfigIni.vue?vue&type=script&lang=js&"
export * from "./ConfigIni.vue?vue&type=script&lang=js&"
import style0 from "./ConfigIni.vue?vue&type=style&index=0&id=3d720647&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d720647",
  null
  
)

export default component.exports